import axios, { AxiosInstance } from 'axios';
import MockAdapter from 'axios-mock-adapter';
import { history } from '../history';
import { authenticationPublicMocks, authenticationSecureMocks } from '../services/authentication/AuthenticationMocks';
import { formPublicMocks } from '../services/form/FormMocks';
import { paymentMocks } from '../services/payment/PaymentMocks';
import { getKreezeeSession, removeKreezeeSession } from './LocalStorage';
import { securityMocks } from '../services/organization/SecurityMock';
import { userMocks } from '../services/user/UserMock';

// Public client
const httpPublicClient = axios.create({
  baseURL: window.configs && window.configs.restapi ? window.configs.restapi : '',
});
const httpPublicClientMocked = axios.create({
  baseURL: window.configs && window.configs.restapi ? window.configs.restapi : '',
});

// Private client
const httpSecureClient = axios.create({
  baseURL: window.configs && window.configs.restapi ? window.configs.restapi : '',
});
const httpSecureClientMocked = axios.create({
  baseURL: window.configs && window.configs.restapi ? window.configs.restapi : '',
});

//Interceptors
httpSecureClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error && error.response) {
      if (error.response.status === 401) {
        removeKreezeeSession();
        history.push('/login');
      }
    }
    return Promise.reject(error);
  },
);

httpSecureClient.interceptors.request.use((config) => {
  config.headers.__kreezeesession__ = getKreezeeSession();
  return config;
});

const localhostClient = axios.create({
  baseURL: 'https://localhost:44301',
});

// Mock
const mockHttpEnabled =
  window.configs && window.configs.mockHttpEnabled !== null ? window.configs.mockHttpEnabled : true;

const mockPublic = new MockAdapter(httpPublicClientMocked, { delayResponse: 500 });
const mockSecure = new MockAdapter(httpSecureClientMocked, { delayResponse: 500 });

function addMocks(client) {
  authenticationPublicMocks(client);
  formPublicMocks(client);
  paymentMocks(client);
  authenticationSecureMocks(client);
  securityMocks(client);
  userMocks(client);
}
addMocks(mockPublic);
addMocks(mockSecure);

//Axios instances
export function getAxiosPublicInstance(forceMocks?: boolean): AxiosInstance {
  if (forceMocks && mockHttpEnabled) {
    return httpPublicClientMocked;
  }
  httpPublicClient.defaults.headers = {
    'Cache-Control': 'no-cache',
  };
  return httpPublicClient;
}

export function getAxiosSecureInstance(forceMocks?: boolean): AxiosInstance {
  if (forceMocks && mockHttpEnabled) {
    return httpSecureClientMocked;
  } else {
    const session = getKreezeeSession();
    httpSecureClient.defaults.headers = {
      Authorization: `Bearer ${session?.jwt}`,
      'Cache-Control': 'no-cache',
    };
    return httpSecureClient;
  }
}

export function getAxiosLocalhostInstance(): AxiosInstance {
  const session = getKreezeeSession();
  localhostClient.defaults.headers = {
    Authorization: `Bearer ${session?.jwt}`,
    'Cache-Control': 'no-cache',
  };
  return localhostClient;
}

export { httpPublicClientMocked, httpSecureClientMocked, mockPublic, mockSecure };
